import { z } from 'zod';
import { normalizeCountryCode } from "./countries.js";
export const STARTING_RATING = 1500;
/** Elo K-factor. 24 moves a rating meaningfully without making it jittery. */
export const RATING_K = 24;
export function expectedScore(rating, opponentRating) {
    return 1 / (1 + 10 ** ((opponentRating - rating) / 400));
}
/**
 * Elo update for a completed match.
 *
 * The margin matters in snooker — a 5-0 is not a 5-4 — so the K-factor is
 * scaled by how one-sided the frames were.
 */
export function nextRating(rating, opponentRating, won, framesWon, framesLost) {
    const total = framesWon + framesLost;
    const margin = total === 0 ? 1 : 1 + Math.abs(framesWon - framesLost) / total;
    const actual = won ? 1 : 0;
    const delta = RATING_K * margin * (actual - expectedScore(rating, opponentRating));
    return Math.round(rating + delta);
}
/** Which table is being ranked. */
export const LeaderboardBoardSchema = z.enum(['rating', 'highest_break', 'practice']);
/**
 * How wide the ranking is drawn. A club player cares far more about being
 * first in their city than four-thousandth in the world.
 */
export const LeaderboardScopeSchema = z.enum(['city', 'country', 'global']);
export const LeaderboardQuerySchema = z.object({
    board: LeaderboardBoardSchema.default('rating'),
    scope: LeaderboardScopeSchema.default('global'),
    /** Required for `city` and `country`; taken from the viewer when omitted. */
    country: z
        .string()
        .trim()
        .optional()
        .transform((code) => (code ? (normalizeCountryCode(code) ?? code) : code)),
    city: z.string().trim().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=stats.js.map